import { baseService } from "./base";
import {
  Permission,
  RolePermission,
} from "../components/admin/operations/backend-setup/types";

export interface UpdateRolePermissionsRequest {
  role: string;
  permissionNames: string[];
}

export const permissionsService = {
  // Get all permissions
  getAllPermissions: async (): Promise<Permission[]> => {
    const response = await baseService.get("/permissions");
    return response.data;
  },

  // Create a new permission
  createPermission: async (
    permission: Omit<Permission, "id" | "isActive">
  ): Promise<Permission> => {
    const response = await baseService.post("/permissions", permission);
    return response.data;
  },

  // Update a permission
  updatePermission: async (
    id: string,
    permission: Partial<Permission>
  ): Promise<Permission> => {
    const response = await baseService.put(`/permissions/${id}`, permission);
    return response.data;
  },

  // Delete a permission
  deletePermission: async (id: string): Promise<void> => {
    await baseService.delete(`/permissions/${id}`);
  },

  // Get permissions for a specific role
  getRolePermissions: async (role: string): Promise<RolePermission[]> => {
    const response = await baseService.get(`/permissions/roles/${role}`);
    return response.data;
  },

  // Get all role permissions
  getAllRolePermissions: async (): Promise<{
    [key: string]: RolePermission[];
  }> => {
    const response = await baseService.get("/permissions/roles");
    return response.data;
  },

  // Update role permissions
  updateRolePermissions: async (
    data: UpdateRolePermissionsRequest
  ): Promise<RolePermission[]> => {
    const response = await baseService.put("/permissions/roles", data);
    return response.data;
  },

  // Initialize default permissions
  initializeDefaultPermissions: async (): Promise<{ message: string }> => {
    const response = await baseService.post("/permissions/initialize");
    return response.data;
  },
};
